import { NgModule } from '@angular/core';
import { SessionStorageServiceModule } from '../session-storage/session-storage.module';
import { SessionAuthDataModule } from './session-auth-data/session-auth-data.module';
import { SessionDataModel } from './session-data.model';

@NgModule({
  declarations: [
  ],
  imports: [
    SessionStorageServiceModule,
    SessionAuthDataModule
  ],
  providers: [
    SessionDataModel
  ]
})
export class SessionDataModule { }
